import React from 'react'

import MenuItem from "./item"
import NewField from "./new-field"
import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import {FieldSelectorConfig} from "../../convert-fields-structure";
import {Group} from "../../../../../data-structures/group";

type Props = {
    section                 : any // ???
    searchQuery             : string
    searchComponent         : any
    noValueOption?          : Option
    config                  : FieldSelectorConfig
    addedColumnsIds?        : ID[]

    isAddVisible            : boolean
    hideEmptyCustomFields?  : boolean

    onSelectSection         : callback
}

export default class Menu extends React.Component<Props> {

    render() {

        const noValueGroup: Group | null = this.props.noValueOption ? {
            value   : 'none',
            label   : this.props.noValueOption.label,
            items   : []
        } : null

        const isSearching = this.props.searchQuery.trim().length > 0

        return (
            <div className="menu ui5-menu">

                {this.props.searchComponent}

                {!isSearching && (
                    <VScroll>
                        {noValueGroup &&
                            <>
                                <MenuItem group             = {noValueGroup}
                                          onSelectSection   = {this.props.onSelectSection}/>
                                <div className="separator-h"/>
                            </>}

                        {_.map(this.props.config.groupedFields, group=>{
                            const isEmpty = group.items?.length === 0
                            switch (group.type) {
                                case 'custom-fields':
                                    // do not skip custom fields group if hideEmptyCustomFields is not true
                                    if (isEmpty && this.props.hideEmptyCustomFields) return
                                    break

                                default:
                                    if (isEmpty) return // skip empty groups
                            }

                            return <MenuItem key                = {group.value}
                                             group              = {group}
                                             addedColumnsIds    = {this.props.addedColumnsIds}
                                             selected           = {group.value === this.props.section}
                                             onSelectSection    = {this.props.onSelectSection}/>
                        })}

                        {this.props.isAddVisible &&
                            <NewField selected          = {'new-field' === this.props.section}
                                      onSelectSection   = {this.props.onSelectSection}/>}

                    </VScroll>
                )}
            </div>
        )
    }
}
